<template>
  <b-modal
    id="add-payment-method"
    ref="add-payment-method"
    size="atto-modals"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get("subscription_card_information") }}
      </h2>
    </div>
    <form method="post" @submit.prevent="addCard">
      <div class="container-wrapper">
        <div class="atto-form">
          <div class="field-row holder">
            <div class="field-wrap">
              <p class="label">
                {{ label.get("subscription_card_holder") }}
                <i class="asterix">*</i>
              </p>
              <!--<input type="text" placeholder="Name on card">-->
              <input
                v-model="card_holder"
                type="text"
                name="card_holder"
                :placeholder="label.get('subscription_name_on_card')"
              />
              <span
                v-if="error && $v.card_holder.$error"
                class="error-message"
                >{{ label.get("subscription_card_holder_is_required") }}</span
              >
            </div>
          </div>
          <div class="field-row cc">
            <div class="field-wrap no">
              <p class="label">
                {{ label.get("subscription_credit_card_number") }}
                <i class="asterix">*</i>
              </p>
              <div id="card-number" />
              <div id="card-errors" class="error-message" role="alert">
                {{ errorMessage }}
              </div>
            </div>
            <div class="field-wrap">
              <p class="label">
                {{ label.get("subscription_credit_card_expiration") }}
                <i class="asterix">*</i>
              </p>
              <div id="card-expiry" />
            </div>
            <div class="field-wrap">
              <p class="label">
                {{ label.get("subscription_credit_card_cvc") }}
                <i class="asterix">*</i>
              </p>
              <div id="card-cvc" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="atto-btn cancel" @click="close">
          {{ label.get("cancel") }}
        </button>
        <button type="submit" class="atto-btn submit">
          {{ label.get("subscription_add_card") }}
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import BillingService from "../services/BillingService";
let cardNumber = null;
export default {
  name: "AddPaymentMethodComponent",
  data: function() {
    return {
      card_holder: "",
      clientSecret: null,
      error: false,
      errorMessage: "",
    };
  },
  validations: {
    card_holder: { required },
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["add-payment-method"].show();
    const _this = this;
    setTimeout(() => {
      const elements = window.stripe.elements();
      const elementStyles = {
        base: {
          color: "#262626",
          fontFamily: "Roboto, sans-serif",
          fontSize: "14px",
          "::placeholder": {
            color: "#999999",
          },
        },
        invalid: {
          color: "#262626",

          "::placeholder": {
            color: "#999999",
          },
        },
      };

      const elementClasses = {
        focus: "focused",
        empty: "empty",
        invalid: "invalid",
      };

      cardNumber = elements.create("cardNumber", {
        style: elementStyles,
        classes: elementClasses,
      });
      const aa = document.getElementById("card-number");
      cardNumber.mount("#card-number");

      let cardExpiry = elements.create("cardExpiry", {
        style: elementStyles,
        classes: elementClasses,
      });
      cardExpiry.mount("#card-expiry");

      let cardCvc = elements.create("cardCvc", {
        style: elementStyles,
        classes: elementClasses,
      });
      cardCvc.mount("#card-cvc");

      cardNumber.addEventListener("change", function(event) {
        if (event.error) {
          _this.errorMessage = event.error.message;
        } else {
          _this.errorMessage = "";
        }
      });
    }, 50);

    this.createSetupIntent();
  },
  methods: {
    createSetupIntent() {
      BillingService.createSetupIntent().then(
        (result) => {
          this.clientSecret = result.intent.client_secret;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    addCard() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let _this = this;
        _this.$store.commit("showLoading");
        window.stripe
          .confirmCardSetup(this.clientSecret, {
            payment_method: {
              card: cardNumber,
              billing_details: {
                name: this.card_holder,
                email: _this.$store.state.user.email,
              },
            },
          })
          .then((result) => {
            if (result.error) {
              _this.errorMessage = result.error.message;
              _this.$store.commit("hideLoading");
            } else {
              let data = {
                card_holder: _this.card_holder,
                paymentMethod: result.setupIntent.payment_method,
              };
              BillingService.addPaymentMethod(data).then(
                (result) => {
                  _this.$store.commit("hideLoading");
                  _this.$awn.success(result.data.message);
                  _this.$root.$emit("hideAddPaymentMethod", result.data.card);
                },
                (error) => {
                  _this.errorMessage = error.response.data.error.message;
                  _this.$store.commit("hideLoading");
                }
              );
            }
          });
      } else {
        this.error = true;
      }
    },

    close: function() {
      this.$root.$emit("hideAddPaymentMethod");
    },
  },
};
</script>

<style lang="scss">
.modal-atto-modals {
  max-width: 640px;
  max-height: 640px;
  position: relative;

  .content-wrapper {
    padding-right: 0px !important;
  }
}

.modal-xs-size {
  .modal-head {
    padding: 40px 40px 16px;
  }
}

.modal-head {
  padding: 48px 48px 16px;

  h2.modal-title {
    font-family: $roboto-font;
    font-weight: $roboto-medium;
    font-size: 1.25rem;
    line-height: 1.75rem;
    color: $atto-font-color;
  }
}

.modal-content {
  .modal-body {
    padding: 0;

    .container-wrapper {
      padding: 8px 48px 24px 48px;

      .atto-form {
        .field-row {
          .field-wrap {
            input::-webkit-input-placeholder {
              color: #999999;
            }
            #card-number,
            #card-expiry,
            #card-cvc {
              width: 100%;
              border: 2px solid #efefef;
              padding: 11px;
              color: #262626;
              font-family: "Roboto", sans-serif;
              font-size: 0.875rem;
              line-height: 1rem;
              font-weight: 400;
              transition: ease all 0.15s;
              min-height: 42px;
            }
          }
        }
        .field-row:last-child {
          margin-bottom: 0;
        }
        .field-row {
          display: flex;
          &.cc {
            .no {
              flex-grow: 1;
            }
            :not(.no).field-wrap {
              width: calc(33.333334% - 32px);
            }
          }
          .field-wrap {
            margin-right: 16px;
            flex-grow: unset;
            width: inherit;
            &:last-child {
              margin-right: 0;
            }
          }
          &.holder {
            width: 100%;
            .field-wrap {
              width: 100%;
            }
          }
        }
      }

      .StripeElement {
        width: 100%;
        border: 2px solid #efefef;
        padding: 11px;
        color: #262626;
        font-family: "Roboto", sans-serif;
        font-size: 0.875rem;
        line-height: 1rem;
        font-weight: 400;
        transition: ease all 0.15s;
        &.focused {
          border-color: #999;
        }

        &.invalid {
          border-color: #e05656;
        }
      }
    }
  }
}

.modal-footer {
  padding: 8px 48px 48px;
  flex-direction: row;

  .atto-btn {
    cursor: pointer;
    font-family: $roboto-font;
    font-weight: 500;
    text-transform: uppercase;
  }
}

@media (max-width: 768px) {
  .modal-atto-modals {
    .modal-content {
      .modal-head {
      }
      .modal-body {
        .container-wrapper {
          .atto-form {
            .field-row {
              margin-bottom: 8px;
            }
            .field-row.cc {
              flex-wrap: wrap;
              .field-wrap {
                width: auto;
                flex-grow: 1;
              }
              .field-wrap.no {
                width: 100%;
                margin-right: 0;
              }
            }
          }
        }
      }
      .modal-footer {
        flex-direction: column;
        button.atto-btn {
          width: 100%;
          &.cancel {
            margin-right: 0;
            margin-top: 10px;
            order: 2;
          }
        }
      }
    }
  }

  #add-payment-method {
    .modal-atto-modals {
      .modal-content {
      }
    }
  }
}
</style>
